import React from "react";
import { useLocation } from "react-router-dom";
import { applyRouteIndexPolicy } from "../lib/routeIndexPolicy";

export default function RouteIndexPolicyBoundary() {
  const { pathname } = useLocation();

  React.useLayoutEffect(() => {
    applyRouteIndexPolicy(document, pathname);
  }, [pathname]);

  return null;
}
